/**
 * @generated SignedSource<<f4562cb376138b0a7ccb0d63c376b240>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContactDataList_contact$data = {
  readonly __typename: string;
  readonly emailAddress: string | null | undefined;
  readonly familyName?: string;
  readonly givenName?: string;
  readonly id: string;
  readonly phoneNumber: string | null | undefined;
  readonly preferredLanguage: string | null | undefined;
  readonly salutation?: string;
  readonly teamName?: string;
  readonly " $fragmentSpreads": FragmentRefs<"SetContactPreferredLanguageDialog_contact" | "UpdatePersonContactDialog_contact" | "UpdateTeamContactDialogProps_contact">;
  readonly " $fragmentType": "ContactDataList_contact";
};
export type ContactDataList_contact$key = {
  readonly " $data"?: ContactDataList_contact$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDataList_contact">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDataList_contact",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "salutation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "givenName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "familyName",
          "storageKey": null
        }
      ],
      "type": "PersonContact",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "teamName",
          "storageKey": null
        }
      ],
      "type": "TeamContact",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emailAddress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "preferredLanguage",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdatePersonContactDialog_contact"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateTeamContactDialogProps_contact"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SetContactPreferredLanguageDialog_contact"
    }
  ],
  "type": "Contact",
  "abstractKey": "__isContact"
};

(node as any).hash = "0dfa918774addeca960ef0707dc5f597";

export default node;
